module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.html
// module id = 1270
// module chunks = 0